import { render, staticRenderFns } from "./PsFilters.vue?vue&type=template&id=c4792a02&scoped=true"
import script from "./PsFilters.vue?vue&type=script&lang=js"
export * from "./PsFilters.vue?vue&type=script&lang=js"
import style0 from "./PsFilters.vue?vue&type=style&index=0&id=c4792a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4792a02",
  null
  
)

export default component.exports